import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Select from 'react-select';

export function SalesManualInputSelect({ options, selectedValue, fieldName, placeholder, isClearable, isMulti, autoFocus, showPill, container }) {
  const [selected, setSelected] = useState(() => {
    if (isMulti) {
      return options.filter((option) => selectedValue.map(String).includes(String(option.value)));
    }
    return options.find((option) => String(option.value) === String(selectedValue)) || null;
  });

  useEffect(() => {
    if (!isMulti || !container) return;
    const selectAll = () => setSelected(options);
    container.addEventListener('select-all-options', selectAll);
    return () => container.removeEventListener('select-all-options', selectAll);
  }, [container, isMulti, options]);

  const hiddenInputs = isMulti
    ? (selected || []).map((option) => (
        <input key={option.value} type="hidden" name={`${fieldName}[]`} value={option.value} />
      ))
    : <input type="hidden" name={fieldName} value={selected?.value ?? ''} />;

  const pillLabel = isMulti ? (selected || []).map((option) => option.label).join(', ') : selected?.label;

  return (
    <>
      {showPill && (
        <div className={`badge badge-pill${pillLabel ? ' activecontent' : ' vhidden'}`}>
          <span className="badge-text">{pillLabel || ' '}</span>
        </div>
      )}
      {showPill && <div className="clearfix" />}
      <Select
        classNamePrefix="brand-select"
        options={options}
        value={selected}
        onChange={setSelected}
        placeholder={placeholder}
        isClearable={isClearable}
        isMulti={isMulti}
        autoFocus={autoFocus}
      />
      {hiddenInputs}
    </>
  );
}

document.querySelectorAll('.sales-manual-input-select').forEach((element) => {
  const options = JSON.parse(element.dataset.options || '[]');
  const isMulti = element.dataset.multi === 'true';
  const selectedValue = isMulti
    ? JSON.parse(element.dataset.selected || '[]')
    : element.dataset.selected || '';
  const root = createRoot(element);
  root.render(
    <SalesManualInputSelect
      options={options}
      selectedValue={selectedValue}
      fieldName={element.dataset.fieldName}
      placeholder={element.dataset.placeholder || 'Select'}
      isClearable={element.dataset.clearable !== 'false'}
      isMulti={isMulti}
      autoFocus={element.dataset.autofocus === 'true'}
      showPill={element.dataset.pill === 'true'}
      container={element}
    />
  );
});
